import { ModelBase } from "../shared/model.base";
import { Grupo } from "../groups/grupo.type";
import { ShortCode } from "../shared/shortcode.type";
import { IdName } from "../shared/id-name.type";
import { User } from "../security/user.type";

export class SmsDTO extends ModelBase {
    execute_end_date: string;
    execute_time: string;
    message: string;
    recurrence_mode: string;
    msisdn: Array<string>;
    groups: Array<Grupo>;
    shortCode: ShortCode;
    template_id: number;
    name: string;
    service_type: string;

    obfuscated: boolean;

    create_date: string;
    execute_date: string;
    id_user: number;
    userId: number;
    user: User;

    operatorId: number;
    operator_id: number;
    organization_short_code_id: number;

    status: ModelBase;
    statusId: number;

    type: string;

    longUrl: string;
    validityPeriod: number;

    constructor() {
        super();

        this.name = "";
        this.recurrence_mode = "1111111";
        this.execute_date = null;
        this.groups = new Array<Grupo>();
        this.status = new ModelBase();
        this.status.id = 1;
        this.statusId = 1;
    }
}
